import { reactive } from "vue";

export const useFeedbackChatStore = reactive({
    showLandingPage: true,
    isOutro: false,
    showChatMessageControls: true,

    setShowLandingPage(value) {
        this.showLandingPage = value;
    },
    setIsOutro(value) {
        this.isOutro = value;
    },
    setShowChatMessageControls(value) {
        this.showChatMessageControls = value;
    },
});
